import { motion } from "framer-motion";
import manDashboard from "./assets/manDashboard.png";

const HomeHero = () => {
  return (
    <motion.section
  initial={{ opacity: 0, y: 50 }}
  whileInView={{ opacity: 1, y: 0 }}
  viewport={{ once: true }}
  transition={{ duration: 0.8, ease: "easeOut" }}
  className="font-epilogue bg-[#F0F7FF] px-4 sm:px-8 md:px-12 lg:px-20 py-10 md:py-14  relative"
>
  <div className="max-w-[1440px] mx-auto flex flex-col lg:flex-row items-center justify-between gap-8">
    <motion.div
      initial={{ opacity: 0, x: -60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.2 }}
      className="w-full lg:w-[55%] text-center lg:text-left"
    >
      <motion.h2
        initial={{ opacity: 0, y: 40, filter: "blur(8px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        transition={{ duration: 0.8, ease: "easeOut" }}
        viewport={{ once: true }}
        className="text-[#181835] font-semibold text-[30px] sm:text-[38px] md:text-[44px] leading-tight mb-4"
      >
        Workforce Management <br className="hidden md:block" /> As It Should Be
      </motion.h2>

      <motion.p
        initial={{ opacity: 0, y: 40, filter: "blur(10px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        transition={{ duration: 1, delay: 0.2, ease: "easeOut" }}
        viewport={{ once: true }}
        className="text-[#5B5B5B] text-[15px] sm:text-[16px] leading-[24px] md:leading-[26px] mb-6 max-w-xl mx-auto lg:mx-0"
      >
        A global leader in the design and implementation of enterprise workforce
        management software built for complex, dynamic environments.
      </motion.p>
      <motion.div
        initial={{ opacity: 0, y: 40, filter: "blur(10px)" }}
        whileInView={{ opacity: 1, y: 0, filter: "blur(0px)" }}
        transition={{ duration: 1, delay: 0.4, ease: "easeOut" }}
        viewport={{ once: true }}
        className="flex flex-wrap justify-center lg:justify-start gap-4 pt-2"
      >
        <motion.a
          whileHover={{ scale: 1.05 }}
          href="/schedule-a-demo"
          className="bg-[#0047FF] text-white font-medium text-sm sm:text-base px-6 sm:px-8 py-2 sm:py-2.5 rounded-xl shadow-md hover:bg-[#003ae6] transition-all duration-300"
        >
          Schedule a Demo
        </motion.a>
      </motion.div>
    </motion.div>
    <motion.div
      initial={{ opacity: 0, x: 60 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.8, ease: "easeOut", delay: 0.3 }}
      className="relative w-full lg:w-[45%] flex justify-center items-center mt-8 lg:mt-0"
    >
      <motion.img
        src={manDashboard}
        alt="Man Dashboard"
        className="w-[95%] sm:w-[100%] md:w-[105%] max-w-[490px] object-contain drop-shadow-xl"
        initial={{ scale: 0.95 }}
        animate={{ scale: 1 }}
        transition={{ duration: 1.2 }}
      />
    </motion.div>
  </div>
</motion.section>
  );
};

export default HomeHero;
